/**
 * Extract the `offset` page param from an API `paging.next` URL.
 *
 * Uses `URLSearchParams` rather than `URL.parse`: the latter is unavailable in
 * older browsers (Chrome <126, Safari <18.4) where it throws
 * `TypeError: URL.parse is not a function`, and it also rejects the relative
 * URLs the API sometimes returns in `paging.next`.
 */
export function getOffsetPageParam(next: string | null | undefined): number | null {
  if (!next) return null;
  const offset = new URLSearchParams(next.split('?')[1] ?? '').get('offset');
  return offset ? parseInt(offset, 10) : null;
}
